import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import * as moment from "moment";

export function AgeValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;

        if (!value) {
            return null;
        }

        const age = moment().diff(value, 'years');

        return !(+age >= 18) ? {ageValidator:true}: null;
    }
}
